import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Link } from 'react-router-dom'
import { Button } from 'rmwc/Button';
import { Card } from 'rmwc/Card';
import * as api from '../../api/api';
import { List, ListItem, ListItemText, ListItemGraphic} from 'rmwc/List';
import ReactGA from 'react-ga';

class SampleQuizUserHome extends Component{
    constructor(props) {
        super(props)
        this.state = {
            data:{
                questionnaires: []
            }
        }
    }

    handleBackAction = (e) => {
        e.preventDefault()
        this.props.history.push('/portal/app/user/questionnaires')
    }

	componentDidMount() {
        ReactGA.set({ userId: this.props.user.id });
        ReactGA.initialize('UA-139837993-1');
        ReactGA.pageview('/sample_quiz_home');

	    let data = Object.assign({}, this.state.data)
	    let global_type_id = 4
	    let url = `questionnaires/type/${global_type_id}`
	    return api.getUserResponse(this.props.user.accessToken, url)
	      .then((result) => {
	        console.log(result)
	        data.questionnaires = result.data
	        this.setState({data: data})
	    })
	}


  handleQuestionnaireView = (e, link, id, type) => {
    this.props.history.push(`/portal/app/user/questionnaire_component/${type}/${id}`)
  }


	render(){
        let handleQuestionnaireView = this.handleQuestionnaireView
        let handleBackAction = this.handleBackAction

		let mainPageContent = (
	          <List>
	          	{this.state.data.questionnaires.map(function(questionnaire) {
	          		let questionnaireLink = questionnaire.questionnaire_link
                    let questionnaireId = questionnaire.id
                    let type = 'quiz'
                    return(
  	          			 <ListItem>
                        <ListItemGraphic>bookmarks</ListItemGraphic>
                        <Typography className = "typography_link" use="headline7" onClick={((e) => handleQuestionnaireView(e,questionnaireLink, questionnaireId, type))}> <a style={{cursor: 'pointer'}}><u>{questionnaire.name}</u></a></Typography>
                     </ListItem>
	          			)

	          	})}
	          </List>
	    )

		 return (
		 		<div> 

		 			<Grid>
            <GridCell span = "12">
                <Card style={{padding: '0px'}}>
                    <Grid className="opportunity-list-item">
                        <GridCell span = "11">
                            <Typography use="headline5">Sample Quizzes</Typography>
                        </GridCell>
                        <GridCell span = "1">
                            <Button raised style={{ width: '100%' }} onClick={((e) => handleBackAction(e))}>Back</Button>
                        </GridCell>
                    </Grid>
                </Card>
            </GridCell>
            <GridCell span = "12">
            <Typography use="subtitle2">Click on the link below to take up relevant Sample Quiz</Typography>
            	
            	{mainPageContent}
            </GridCell>
        	</Grid>


		 		</div>

		 	)
	}

}


function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(SampleQuizUserHome);


// WEBPACK FOOTER //
// ./src/views/questionnaire/SampleQuizUserHome.jsx